import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  CardActionArea,
  CircularProgress,
  Box,
  Tooltip,
  Stack,
} from "@mui/material";
import axios from "axios";

const Labs = () => {
  const navigate = useNavigate();
  const [labs, setLabs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    fetchLabs();
  }, []);

  const fetchLabs = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        "https://api.nvcti.in/labs/getAllLabs",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      //console.log("re",response);
      if (!response.data.success) {
        throw new Error(response.data.message || "Failed to fetch labs");
      }

      const formattedLabs = response.data.data.map((lab) => ({
        id: lab.lab_id,
        name: lab.lab_name,
      }));

      setLabs(formattedLabs);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching labs:", error);
      setLoading(false);
    }
  };

  const handleCardClick = (id) => {
    navigate(`/student/inventory/labs/${id}`);
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="80vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <div className="relative w-full">
      <div className="flex justify-between items-center px-4 mt-6">
        <p className="font-semibold text-lg text-white">All Labs </p>
      </div>

      <div className="px-6 mt-4 mb-6">
        <form className="flex flex-row flex-wrap items-center">
          <div className="relative flex w-full flex-wrap items-stretch">
            <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-900 bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
              <i className="fas fa-search"></i>
            </span>
            <Tooltip title="Search Lab Name" arrow>
              <input
                type="text"
                placeholder="Search by Lab Name"
                className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:ring w-full pl-10 pr-10"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </Tooltip>
            {searchTerm && (
              <button
                type="button"
                onClick={() => setSearchTerm("")}
                className="absolute right-0 top-0 bottom-0 flex items-center justify-center w-10 text-blueGray-900 hover:text-blueGray-600 focus:outline-none"
              >
                <i className="fas fa-times"></i>
              </button>
            )}
          </div>
        </form>
      </div>

      <Grid container spacing={4}>
        {labs
          .filter((lab) =>
            lab.name.toLowerCase().includes(searchTerm.toLowerCase())
          )
          .map((lab) => (
            <Grid item xs={12} sm={6} md={4} key={lab.id}>
              <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
                <CardActionArea onClick={() => handleCardClick(lab.id)}>
                  <CardContent>
                    <Typography
                      gutterBottom
                      variant="h6"
                      component="div"
                      sx={{ fontWeight: 600 }}
                    >
                     {lab.name.length > 31 ? `${lab.name.slice(0, 31)}...` : lab.name}
                    </Typography>
                    <Stack direction="row" spacing={1}>
                      <Typography variant="body2" color="text.secondary">
                        Click to view inventory
                      </Typography>
                    </Stack>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
      </Grid>
    </div>
  );
};

export default Labs;
